// App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppLayout from "./layouts/AppLayout";
import RotationDetail from "./pages/RotationDetail";
import RotationDetailStructured from "./pages/RotationDetailStructured";
import EventListView from "./pages/EventListView";
import Cookies from "js-cookie";

import Home from "./pages/Home";
import Login from "./auth/Login";
import Register from "./auth/Register";
import VerifyOtp from "./auth/VerifyOtp";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import ForgotPassword from "./auth/ForgotPassword";
import ResetPassword from "./auth/ResetPassword";
import OAuthSuccess from "./auth/OAuthSuccess";
import ContactUs from "./pages/ContactUs";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import ProfessionalSetup from "./pages/ProfessionalSetup";
import CalendarSetup from "./pages/CalendarSetup";
import EventsPage from "./pages/EventsPage";

import "./style/index.css";

import ProfessionalProfile from "./pages/ProfessionalProfile";
import ProfessionalSettingsReview from "./pages/ProfessionalSettingsReview";
import SetupCalendarPage from "./pages/SetupCalendarPage";


// Routes wrappers
import ProtectedRoute from "./routes/ProtectedRoute";
import AuthRoute from "./routes/AuthRoute";
import LandingRoute  from "./routes/LandingRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingRoute />} />
        <Route path="/login" element={<AuthRoute><Login /></AuthRoute>} />
        <Route path="/register" element={<AuthRoute><Register /></AuthRoute>} />
        <Route path="/forgot-password" element={<AuthRoute><ForgotPassword /></AuthRoute>} />
        <Route path="/reset-password" element={<AuthRoute><ResetPassword /></AuthRoute>} />
        <Route path="/verify-otp" element={<AuthRoute><VerifyOtp /></AuthRoute>} />
        <Route path="/oauth-success" element={<AuthRoute><OAuthSuccess /></AuthRoute>} />

		 <Route element={<AppLayout />}>
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

        
        <Route path="/change-password" element={<ProtectedRoute><ChangePasswordPage /></ProtectedRoute>} />

        
        <Route path="/contact" element={<ProtectedRoute><ContactUs /></ProtectedRoute>} />

     
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />

      
        <Route path="/professional-setup" element={<ProtectedRoute><ProfessionalSetup /></ProtectedRoute>} />
		
		<Route
			path="/calendar-setup"
			element={
				<ProtectedRoute>
					<CalendarSetup />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/setup-calendar"
			element={
				<ProtectedRoute>
					<SetupCalendarPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/events"
			element={
				<ProtectedRoute>
					<EventsPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/professional-profile"
			element={
				<ProtectedRoute>
					<ProfessionalProfile />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/professional-settings"
			element={
				<ProtectedRoute>
					<ProfessionalSettingsReview />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/rotation/:eventUid"
			element={
<ProtectedRoute>
<RotationDetailStructured />
</ProtectedRoute>
			}
		/>
<Route
			path="/rotation-original/:eventId"
			element={
<ProtectedRoute>
<RotationDetail />
</ProtectedRoute>
			}
		/>
<Route
			path="/rotation-clone/:eventId"
			element={
<ProtectedRoute>
<RotationDetailStructured />
</ProtectedRoute>
			}
		/>
<Route
			path="/list-view"
			element={
<ProtectedRoute>
<EventListView />
</ProtectedRoute>
			}
		/>
</Route>
    
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
